import { Component, ElementRef, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { StudentsResponse, ClassDetail, Student, PelicanHRMContent } from '../../Models/Session';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { TranslateService } from '@ngx-translate/core';
import { Device } from '@capacitor/device';
import { Preferences } from '@capacitor/preferences';
;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  encapsulation:ViewEncapsulation.None,standalone:false
})
export class NavbarComponent implements OnInit {
  changelog: string = 'v3.1.0';
  isDarkTheme: boolean = false;
  shouldReloadPage = false;
  selectedLanguage: string = 'en';
  Users:StudentsResponse[]=[];
  classes:ClassDetail[]=[];
  userId:string='';
  user!:Student
  userRole:string=''
  users: StudentsResponse[] = [];
  selectedUser: any;
  localLang:string='French'
  img:string='../../../assets/images/fr.PNG';
  isSticky: boolean = false;
  loading:boolean=false
  sessionDataArray:PelicanHRMContent[]=[];
  BusinessSize: PelicanHRMContent[] = [];
  BusinessType: PelicanHRMContent[] = [];
  Industry: PelicanHRMContent[] = [];
  Company: PelicanHRMContent[] = [];
  Resources:PelicanHRMContent[] = [];
  Support: PelicanHRMContent[] = [];
  SystemPages: PelicanHRMContent[] = [];
  constructor
  (

      private renderer: Renderer2,
      private api:BaseApiService,
      private auth:AuthService,
      private messageService:MessageService,
      private Router:Router,
      private el: ElementRef,
      private translate :TranslateService
  )
  {

    this.userId=this.auth.getUID();
    this.userRole=this.auth.getRoles().toString();

     const savedLanguage = localStorage.getItem('selectedLanguage');
     if (savedLanguage) {
       this.selectedLanguage = savedLanguage;
       this.localLang=this.api.getLang(this.selectedLanguage);
  }

   }


    // Switch language and persist it
  async switchLanguage(event: Event): Promise<void> {
    const selectedLanguage = (event.target as HTMLSelectElement).value;

    // Use ngx-translate to switch the language
    this.translate.use(selectedLanguage);

    // Detect platform (iOS or Web) using Capacitor Device plugin
    const info = await Device.getInfo();
    if (info.platform === 'ios') {
      // For iOS, use Capacitor Preferences to store the selected language
      Preferences.set({
        key: 'language',
        value: selectedLanguage,
      });
    } else {
      // For Web, use localStorage to store the selected language
      localStorage.setItem('language', selectedLanguage);
    }
  }

  showSidebar: boolean = true;
  showSide:boolean=false;
  toggleColumnLayout() {
    // Toggle the sidebar visibility
    this.showSidebar = !this.showSidebar;

    // Toggle the column layout
    if (this.showSidebar) {
      // Display the sidebar column and adjust widths
      this.renderer.addClass(document.querySelector('#db-wrapper'), 'toggled');
    } else {
      // Hide the sidebar column and adjust widths
      this.renderer.removeClass(document.querySelector('#db-wrapper'), 'toggled');


    }




  }


  @HostListener('window:scroll', [])
  onWindowScroll() {
   const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

   if (scrollPosition >= 1) { // Adjust the threshold as needed
     this.renderer.addClass(this.el.nativeElement, 'sticky');
     this.isSticky = true;
   } else {
     this.renderer.removeClass(this.el.nativeElement, 'sticky');
     this.isSticky = false;
   }
 }




  getdata(uid:any){
    this.api.read(`Auth/getById?uid=${uid}`).subscribe
    (
      (response)=>{
        this.user = response;
      }
      ,(
        error
      )=>{
        //this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }

  getPages() {
    this.loading = true;
    this.api.read('Page/GetAllPages').subscribe(
      (response) => {

        this.sessionDataArray = response;

        this.Company          = this.sessionDataArray.filter(x=>x.subCategory=="Company");
        this.Resources        = this.sessionDataArray.filter(x=>x.subCategory=="Resources" || x.subCategory=="About");
        this.Support          = this.sessionDataArray.filter(x=>x.subCategory=="Support");

        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  logOut(){
    this.auth.logout();
    this.Router.navigate(['/login']);
  }


  ngOnInit() {
    this.getPages();
    if(this.userId!=''){
      this.getdata(this.userId);
    }
    const theme = localStorage.getItem('theme');
    if (theme === 'dark') {
      this.isDarkTheme = true;
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      this.isDarkTheme = false;
      document.documentElement.setAttribute('data-theme', 'light');
    }

  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    if (this.isDarkTheme) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }

  }





}
